import React, { useEffect } from 'react'
import { updateBroadcast } from "reducers/authenticationSlice";
import { connect } from 'react-redux';
import { notification } from "antd";
// import { PatientMessage } from 'config/routersConstants';

const FcmReciever = ({...props}) => {
    const pushFcmEvent = new BroadcastChannel('pushFcmEvent');
    const clickEvent = new BroadcastChannel('clickEvent');
       
    useEffect(() => {
      pushFcmEvent.onmessage = (event) => {
            if(event?.data) {
                props.updateBroadcast(event.data);
                openNotification(event.data);
            }
            
        }
        clickEvent.onmessage = (event) => {
            handleNotificationClick();
        }
    }, []);

    const openNotification = ({title, description}) => {
        notification.open({
          message: title,
          description: description,
          onClick: ()=>{ handleNotificationClick() 
        }
      
        });
      };

      const handleNotificationClick = () =>{
        // window.location.assign(PatientMessage.path)
      }
    return null
    
}
const mapDispatchToProps = { updateBroadcast };
type DispatchProps = typeof mapDispatchToProps;
export default connect(null, mapDispatchToProps)(FcmReciever);
